import WarningPage from "./WarningPage";

export default WarningPage;
